import { TableColumn } from 'element-ui'

const YTableColumn = TableColumn
YTableColumn.$depends = [TableColumn]
YTableColumn.$name = 'y-table-column'
YTableColumn._name = 'TableColumn 表格字段'

export default YTableColumn
